import React from "react";
import { useTranslation } from "@localization/useTranslation.ts";
import IncidentLogTextWithSuggestionsField from "../IncidentLogTextWithSuggestionsField.tsx";
import { useIncidentLogMeasuresField } from "./IncidentLogMeasuresField.hooks.ts";

export interface IncidentLogMeasuresFieldProps {
    measures?: string;
    onChange: (measures: string) => void;
    isPreview: boolean;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogMeasuresField(props: IncidentLogMeasuresFieldProps) {
    const { translateString } = useTranslation();
    const { securityMeasureSuggestions } = useIncidentLogMeasuresField(props.isPreview);

    return (
        <IncidentLogTextWithSuggestionsField
            label={translateString("incidentMeasure")}
            placeholder={translateString("incidentMeasureTextFieldPlaceholder")}
            suggestionsHeader={translateString("incidentMeasureSuggestions")}
            suggestions={securityMeasureSuggestions}
            isPreview={props.isPreview}
            value={props.measures}
            onChange={props.onChange}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default IncidentLogMeasuresField;
